import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { userActions } from '~/behaviors/actions/user.actions';

const defaultState = {};

const reset = () => defaultState;

/**
 * Iterate over each element of `action.payload.users` and merge each with any
 * existing entity with the same ID in the state (or create new one if none exist).
 */
const mergeUsers = (state, action) => {
  const users: any[] = action?.payload?.entities?.users || [];

  Object.values(users).forEach((user) => {
    state[user.id] = {
      ...state[user.id],
      ...user,
    };
  });
};

const adminUsers = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(userActions.fetchAdminUsers.fulfilled, mergeUsers);
});

export default adminUsers;
